import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import DownloadLinks from './DownloadLinks';
import Spin from './Common/Spin';

function Home(props) {
  const queryParams = queryString.parse(props.location.search);
  // eslint-disable-next-line dot-notation
  return queryParams['_branch_match_id']
    ? <Spin cover />
    : <DownloadLinks {...props} />;
}

Home.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default Home;
